import { render } from "./NewFromBlank.vue?vue&type=template&id=1adf3275"
import script from "./NewFromBlank.vue?vue&type=script&lang=js"
export * from "./NewFromBlank.vue?vue&type=script&lang=js"

import "./NewFromBlank.vue?vue&type=style&index=0&id=1adf3275&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__